import hgpInputNumber from './src/input-number';

export default {
  install(Vue) {
    Vue.component(hgpInputNumber.name, hgpInputNumber);
  },
};